module.exports = __webpack_public_path__ + "static/media/Organic4colorsealGIF.b9b3fde1.gif";